<template>
    <div class="goods_details_content">
        <div class="goods_details_top_content">
            <div class="img_magnifier_content">
                <imgMagnifier :imglist="goodsinfo.imglist"></imgMagnifier>
            </div>
            <div class="goods_info_content">
                <div class="goods_info_top">
                    <div class="goods_info_name">
                        <h3>
                            <b v-if="goodsinfo.cxtype == 1" style="background-color: #FF8000">特价</b>
                            <b v-if="goodsinfo.cxtype == 2" style="background-color: #40a250">折扣</b>
                            <b v-if="goodsinfo.cxtype == 3" style="background-color: #FF8000">促销</b>
                            {{goodsinfo.name}}
                        </h3>
                    </div>
                    <div class="goods_info_price">
                        <span>市场价：￥{{goodsinfo.minmcost}}/{{goodsinfo.unit}}</span>
                        <span>编号：{{goodsinfo.commcode}}</span>
                    </div>
                    <div class="goods_info_specialoffer" v-if="false">
                        <!-- <span>特价</span>
                        <small>6全尺寸全颜色特价，优惠减30</small> -->
                    </div>
                    <div class="goods_info_label" v-if="goodsinfo.labelids != ''">
                        <span v-for="(item, index) in goodsinfo.labelids" :key="index">{{item}}</span>
                    </div>
                </div>
                <!-- 单规格 -->
                <div class="goods_info_norms_content" v-if="goodsinfo.is_det == 0">
                    <div class="goods_info_norms_head">
                        <Row>
                            <Col span="7"><span class="goods_info_norms_txt">订货价</span></Col>
                            <Col span="6"><span class="goods_info_norms_txt" v-if="stockShow == 2">库存</span></Col>
                            <Col span="6">
                                <span class="goods_info_norms_txt">
                                    起订{{goodsinfo.unitshow && goodsinfo.minorderunit == 'unit' ? (Math.ceil(parseInt(goodsinfo.minordernum)/parseInt(goodsinfo.matrixing))) :  goodsinfo.minordernum}}{{goodsinfo.unitshow ? goodsinfo.maxunit : goodsinfo.unit}} &nbsp;&nbsp;
                                    <span v-if="goodsinfo.doubleunit == 2">1{{goodsinfo.maxunit}}={{goodsinfo.matrixing}}{{goodsinfo.unit}}</span>
                                </span>
                            </Col>
                        </Row>
                    </div>
                    <div class="goods_info_norms_body">
                        <Row class="goods_info_norms_body_list">
                            <Col span="7"><span class="goods_info_norms_txt">¥{{det.cxinfo.is_cx == 1 ? (goodsinfo.unitshow ? ((det.cxinfo.cxcost * goodsinfo.matrixing).toFixed(2)) : det.cxinfo.cxcost) : (goodsinfo.unitshow ? ((det.cost * goodsinfo.matrixing).toFixed(2)) : det.cost)}}</span></Col>
                            <Col span="6" v-if="stockShow == 2"><span class="goods_info_norms_txt">{{det.stock}}{{goodsinfo.unitshow ? goodsinfo.maxunit : goodsinfo.unit}}</span></Col>
                            <Col span="6">
                                <div class="goods_list_num_content" v-if="det.stock > goodsinfo.minordernum || outstock == 1">
                                    <div class="goods_list_num">
                                        <span @click="minBtn(goodsinfo, goodsinfo.minorderunit, goodsinfo.minordernum, goodsinfo.matrixing)">-</span>
                                        <div class="goodsnum_select">
                                            <InputNumber class="goodsnum" v-model="goodsinfo.num" :min="0" @on-blur="goodsnumBlur(goodsinfo, det.cxinfo, det.stock, goodsinfo.minorderunit, goodsinfo.minordernum, goodsinfo.matrixing, goodsinfo.maxunit, goodsinfo.unit)"></InputNumber>
                                            <i class="icon iconfont icon-xingzhuangjiehe" v-if="goodsinfo.carcheck"></i>
                                        </div>
                                        <span @click="addBtn(goodsinfo, det.cxinfo, det.stock, goodsinfo.minorderunit, goodsinfo.minordernum, goodsinfo.matrixing, goodsinfo.maxunit, goodsinfo.unit)">+</span>
                                    </div>  
                                    <Tooltip :content="goodsinfo.unitshow ? goodsinfo.maxunit : goodsinfo.unit" theme="light" placement="top">
                                        <div class="goods_list_unit" :style="{width: goodsinfo.doubleunit == 1 || goodsinfo.minorderunit == 'maxunit' ? '23px' : ''}" @click.stop="unitChange(goodsinfo, det.cxinfo, det.stock, goodsinfo.minorderunit, goodsinfo.minordernum, goodsinfo.matrixing, goodsinfo.maxunit, goodsinfo.unit, goodsinfo.doubleunit)"><span>{{goodsinfo.unitshow ? goodsinfo.maxunit : goodsinfo.unit}}</span><i class="icon iconfont icon-xialazhankai" v-if="goodsinfo.doubleunit == 2 && goodsinfo.minorderunit == 'unit'"></i></div>
                                    </Tooltip>
                                </div>
                                <span class="goods_info_norms_txt" v-else>缺货</span>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div class="goods_info_center" v-else> <!-- 多规格 -->
                    <div class="goods_info_list mr10" v-if="goodsattr.length >= 2">
                        <span>{{goodsattr[0].name}}：</span>
                        <ul>
                            <li :class="[oneActive == index ? 'active' : '']" v-for="(item, index) in goodsattr[0].det" :key="index" @click="normsclick(0, index, item.id)">
                                <img :src="item.img" v-if="item.img != ''" />
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="goods_info_list mr10" v-if="goodsattr.length >= 3">
                        <span>{{goodsattr[1].name}}：</span>
                        <ul>
                            <li :class="[twoActive == index ? 'active' : '']" v-for="(item, index) in goodsattr[1].det" :key="index" @click="normsclick(1, index, item.id)">
                                <img :src="item.img" v-if="item.img != ''" />
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="goods_info_norms_content">
                        <div class="goods_info_norms_head">
                            <Row>
                                <Col span="5"><span class="goods_info_norms_txt">型号</span></Col>
                                <Col span="7"><span class="goods_info_norms_txt">订货价</span></Col>
                                <Col span="6"><span class="goods_info_norms_txt" v-if="stockShow == 2">库存</span></Col>
                                <Col span="6">
                                    <span class="goods_info_norms_txt">
                                        起订{{goodsinfo.minordernum}}{{goodsinfo.unit}}
                                        <span v-if="goodsinfo.doubleunit == 2">1{{goodsinfo.maxunit}}={{goodsinfo.matrixing}}{{goodsinfo.unit}}</span>
                                    </span>
                                </Col>
                            </Row>
                        </div>
                        <div class="goods_info_norms_body" v-if="goodsattr[(goodsattr.length == 1 ? 0 : (goodsattr.length == 2 ? 1 : 2))]">
                            <Row
                                class="goods_info_norms_body_list"
                                v-for="(i, iindex) in goodsattr[(goodsattr.length == 1 ? 0 : (goodsattr.length == 2 ? 1 : 2))].det"
                                :key="iindex">
                                <Row
                                    v-for="(j, jindex) in det"
                                    :key="jindex"
                                    v-if="(goodsattr.length == 1 ? i.id : (goodsattr.length == 2 ? tabs1 + ',' + i.id : tabs1 + ',' + tabs2 + ',' + i.id)) == j.gg_ids">
                                    <Col span="5">
                                        <span class="goods_info_norms_txt">
                                            <b v-if="j.cxinfo.type == 1" style="background-color: #FF8000">特价</b>
                                            <b v-if="j.cxinfo.type == 2" style="background-color: #40a250">折扣</b>
                                            <b v-if="j.cxinfo.type == 3" style="background-color: #FF8000">促销</b>
                                            {{i.name}}
                                        </span>
                                    </Col>
                                    <Col span="7">
                                        <span class="goods_info_norms_txt" v-if="j.unitshow && j.cxinfo.is_cx != 1">
                                            ¥{{(j.cost * goodsinfo.matrixing).toFixed(2)}}/{{j.unitshow ? goodsinfo.maxunit : goodsinfo.unit}}
                                        </span>
                                        <span class="goods_info_norms_txt" v-else-if="!j.unitshow && j.cxinfo.is_cx != 1">
                                            ¥{{j.cost}}/{{j.unitshow ? goodsinfo.maxunit : goodsinfo.unit}}
                                        </span>
                                        <span class="goods_info_norms_txt" v-else-if="j.unitshow && j.cxinfo.is_cx == 1">
                                            ¥{{(j.cxinfo.cxcost * goodsinfo.matrixing).toFixed(2)}}<del>（{{j.cost}}）</del>/{{j.unitshow ? goodsinfo.maxunit : goodsinfo.unit}}
                                        </span>
                                        <span class="goods_info_norms_txt" v-else>
                                            ¥{{j.cxinfo.cxcost}}<del>（{{j.cost}}）</del>/{{j.unitshow ? goodsinfo.maxunit : goodsinfo.unit}}
                                        </span>
                                    </Col>
                                    <Col span="6" v-if="stockShow == 2"><span class="goods_info_norms_txt">{{j.stock || 0}}{{j.unitshow ? goodsinfo.maxunit : goodsinfo.unit}}</span></Col>
                                    <Col span="6">
                                        <div class="goods_list_num_content" v-if="j.stock >= goodsinfo.minordernum || outstock == 1">
                                            <div class="goods_list_num">
                                                <span @click="minBtn(j, goodsinfo.minorderunit, goodsinfo.minordernum, goodsinfo.matrixing)">-</span>
                                                <div class="goodsnum_select">
                                                    <InputNumber class="goodsnum" v-model="j.num" :min="0" @on-blur="goodsnumBlur(j, j.cxinfo, j.stock, goodsinfo.minorderunit, goodsinfo.minordernum, goodsinfo.matrixing, goodsinfo.maxunit,  goodsinfo.unit)"></InputNumber>
                                                    <i class="icon iconfont icon-xingzhuangjiehe" v-if="j.carcheck"></i>
                                                </div>
                                                <span @click="addBtn(j, j.cxinfo, j.stock, goodsinfo.minorderunit, goodsinfo.minordernum, goodsinfo.matrixing, goodsinfo.maxunit,  goodsinfo.unit)">+</span>
                                            </div>
                                            <Tooltip :content="j.unitshow ? goodsinfo.maxunit : goodsinfo.unit" theme="light" placement="top">
                                                <div class="goods_list_unit" :style="{width: goodsinfo.doubleunit == 1 || goodsinfo.minorderunit == 'maxunit' ? '23px' : ''}" @click.stop="unitChange(j, j.cxinfo, j.stock, goodsinfo.minorderunit, goodsinfo.minordernum, goodsinfo.matrixing, goodsinfo.maxunit, goodsinfo.unit, goodsinfo.doubleunit)"><span>{{j.unitshow ? goodsinfo.maxunit : goodsinfo.unit}}</span><i class="icon iconfont icon-xialazhankai" v-if="goodsinfo.doubleunit == 2 && goodsinfo.minorderunit == 'unit'"></i></div>
                                            </Tooltip>
                                        </div>
                                        <span class="goods_info_norms_txt" v-else>缺货</span>
                                    </Col>
                                </Row>
                            </Row>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div class="goods_info_bottom">
                    <Button
                        class="goods_info_btn"
                        type="warning"
                        :style="{
                            backgroundColor: outstock <= 0 && hasstock == 0 ? '#ccc' : '',
                            borderColor: outstock <= 0 && hasstock == 0 ? '#ccc' : '',
                        }"
                        @click="addGoods">
                            加入购物车
                        </Button>
                    <Button class="goods_info_btn" :class="{collect: is_collect == 0}" :type="is_collect == 1 ? 'warning' : 'default'" ghost @click="collectclick">
                        <Icon type="md-star-outline" size="24" v-if="is_collect == 0" />
                        <Icon type="md-star" size="24" v-else />
                        收藏
                    </Button>
                </div>
            </div>
        </div>
        <div class="goods_details_interval h"></div>
        <div class="goods_details_bottom_content">
            <div class="goods_details_introduce_content">
                <div class="goods_details_introduce_box">
                    <Tabs>
                        <TabPane label="商品参数">
                            <div class="goods_details_introduce_table">
                                <table>
                                    <colgroup>
                                        <col width="17.3333%">
                                        <col width="32.6666%">
                                        <col width="17.3333%">
                                        <col width="32.6666%">
                                    </colgroup>
                                    <tbody>
                                        <tr v-for="(item, index) in goodsparameter" :key="index">
                                            <th>{{item[0].title}}</th>
                                            <td>{{item[0].content}}</td>
                                            <th v-if="item[1] != undefined">{{item[1].title}}</th>
                                            <!-- <th v-else></th> -->
                                            <td v-if="item[1] != undefined">{{item[1].content}}</td>
                                            <!-- <td v-else></td> -->
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
                <div class="goods_details_introduce_box">
                    <Tabs>
                        <TabPane label="商品详情">
                            <div class="goods_details_introduce_describe" v-html="goodsinfo.instro"></div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
            <div class="goods_details_interval v"></div>
            <div class="goods_browsinghistory_content">
                <Tabs>
                    <TabPane label="浏览过的">
                        <div class="goods_browsinghistory_list" v-if="goodsBrowsingHistory">
                            <ul>
                                <li v-for="(item, index) in goodsBrowsingHistory" :key="index" v-if="index < 8" @click="goto(item.id)">
                                    <div class="goods_browsinghistory_left" :style="{backgroundImage: 'url(' + item.img + ')'}"></div>
                                    <div class="goods_browsinghistory_right">
                                        <div class="goods_browsinghistory_name"><h3>{{item.name}}</h3></div>
                                        <div class="goods_browsinghistory_price">
                                            <span>¥{{item.mincost}}</span>
                                            <small>/{{item.unit}}</small>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        </div>
        <noLoginTips :nologinShow="nologinShow" :nologintipsmsg="nologintipsmsg" @nologinOk="nologinOk" @nologinCancel="nologinCancel"></noLoginTips>
    </div>
</template>

<script>
import api from '@/request/api.js'
import imgMagnifier from "@/components/component/imgMagnifier.vue"
import goodsNorms from "@/components/component/goodsnorms.vue"
import noLoginTips from '@/components/component/popup/nologintips.vue'
import {add, min, unitChange, numBlur} from '@/assets/js/addcart.js'
export default {
    components: {imgMagnifier, goodsNorms, noLoginTips},
    data() {
        return {
            outstock: 0, // 是否允许超库存购买 1 允许客户购买下单
            stockShow: 0, // 是否显示库存 1 不显示 2 显示
            hasstock: 0, // 有无库存（加入购物车按钮判断是否有库存） 0 无 1 有
            goodsinfo: {}, // 商品信息
            goodspecsinfo: null, // 商品规格信息，如果没有规格返回 false 如果有返回数组
            goodsdet: [], // 商品规格组合
            goodsattr: [], // 商品规格
            det: [], // 商品规格组合
            normsId: [], // 规格id
            goodsparameter: [], // 商品参数 - 表格展示
            goodsBrowsingHistory: [], // 浏览记录
            oneActive: 0, // 多规格 --- 第一个分类当前选中
            twoActive: 0, // 多规格 --- 第二个分类当前选中
            goodsid: '',
            tabs1: '',
            tabs2: '',
            is_collect: 0, // 是否收藏
            nologinShow: false, // 未登录弹窗是否显示
            nologintipsmsg: false, // 未登录弹窗信息
        }
    },
    methods: {
        getGoodsDetails () { // 获取商品详情
            this.http.post(api.goodsdetail, {id: this.$route.params.id})
            .then(response => {
                /**
                 *  market_productinfo --- 商品规格信息
                 *  marketgoods_ggfids --- 商品所有规格父类（父规格）集合  如 id  10   [  10的 子类 是 75.76]
                 *  marketgoods_ggids --- 商品所有规格（子规格） 的集合   如  id 75,76 
                 *  marketgoods_goodsdet --- 商品规格信息  内字段 custypecost  客户类型指定价格  cusuidcost指定客户的指定价格
                 *  marketgoods_onegoods --- 商品信息
                 */
                // console.log(response.data.msg.marketgoods_onegoods)
                // console.log(response.data.msg.market_productinfo)
                console.log(response.data.msg)

                if (response.data.msg.marketgoods_onegoods.is_det == 0) { // 0 单规格 1 多规格
                    response.data.msg.marketgoods_onegoods.num = 0
                    response.data.msg.marketgoods_onegoods.minorderunit == 'maxunit' ? response.data.msg.marketgoods_onegoods.unitshow = true : response.data.msg.marketgoods_onegoods.unitshow = false
                    // 是否加入购物车图标
                    response.data.msg.marketgoods_onegoods.carcheck = false
                } else if (response.data.msg.marketgoods_onegoods.is_det == 1) {
                    for (var i = 0; i < response.data.msg.marketgoods_goodsdet.length; i++) {
                        response.data.msg.marketgoods_goodsdet[i].num = 0
                        response.data.msg.marketgoods_onegoods.minorderunit == 'maxunit' ? response.data.msg.marketgoods_goodsdet[i].unitshow = true : response.data.msg.marketgoods_goodsdet[i].unitshow = false
                        // 是否加入购物车图标
                        response.data.msg.marketgoods_goodsdet[i].carcheck = false
                    }
                }

                if (this.$store.state.shopcartlist.length > 0) {
                    if (response.data.msg.marketgoods_onegoods.is_det == 0) { // 0 单规格 1 多规格
                        for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                            if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.marketgoods_goodsdet.gg_id) {
                                response.data.msg.marketgoods_onegoods.num = this.$store.state.shopcartlist[i].num
                                response.data.msg.marketgoods_onegoods.unitshow = this.$store.state.shopcartlist[i].unitshow
                                // 是否加入购物车图标
                                response.data.msg.marketgoods_onegoods.carcheck = true
                            }
                        }
                    } else {
                        for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                            for (var j = 0; j < response.data.msg.marketgoods_goodsdet.length; j++) {
                                if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.marketgoods_goodsdet[j].gg_id) {
                                    response.data.msg.marketgoods_goodsdet[j].num = this.$store.state.shopcartlist[i].num
                                    response.data.msg.marketgoods_goodsdet[j].unitshow = this.$store.state.shopcartlist[i].unitshow
                                    // 是否加入购物车图标
                                    response.data.msg.marketgoods_goodsdet[j].carcheck = true
                                }
                            }
                        }
                    }
                }

                this.goodsinfo = response.data.msg.marketgoods_onegoods
                this.goodsparameter = response.data.msg.marketgoods_onegoods.cuslabelids
                this.hasstock = response.data.msg.marketgoods_onegoods.hasstock
                this.goodsattr = response.data.msg.market_productinfo
                this.det = response.data.msg.marketgoods_goodsdet
                // 是否显示库存
                this.stockShow = response.data.msg.depository_show
                // 是否允许超库存购买
                this.outstock = response.data.msg.depository_dinghuominus
                // 是否限制下单
                this.banorder = response.data.msg.orderlimit
                // 是否收藏
                this.is_collect = response.data.msg.is_collect

                if (this.goodsattr.length == 1) {
                    this.goodsid = this.goodsattr[0].det[0].id + ''
                } else if (this.goodsattr.length == 2) {
                    this.goodsid = this.goodsattr[0].det[0].id + ',' + this.goodsattr[1].det[0].id
                    this.tabs1 = this.goodsattr[0].det[0].id
                } else if (this.goodsattr.length == 3) {
                    this.goodsid = this.goodsattr[0].det[0].id + ',' + this.goodsattr[1].det[0].id + ',' + this.goodsattr[2].det[0].id
                    this.tabs1 = this.goodsattr[0].det[0].id
                    this.tabs2 = this.goodsattr[1].det[0].id
                }
            })
            .catch(error => {
                this.$Message.error(error)
            })
        },
        getNormsId (e) { // 获取选择后的规格id
            this.normsId = e
        },
        normsclick (sign, index, id) { // 多规格弹窗 点击切换商品规格 sign 如果norms大于1条 表示第一行的
            let arr = []
            arr = this.goodsid.split(',')
            if (sign == 0) {
                this.oneActive = index
                arr[0] = this.tabs1 = id
            } else if (sign == 1) {
                this.twoActive = index
                arr[1] = this.tabs2 = id
            }
            this.goodsid = arr.join(',')
        },
        minBtn (item, minorderunit, minordernum, matrixing) { // 减数量
            item.num = min(item, minorderunit, minordernum, matrixing)
        },
        addBtn (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit) { // 加数量
            item.num = add(item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, this.outstock)
        },
        goodsnumBlur (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit) { // 输入数量
            item.num = numBlur(item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, this.outstock)
        },
        unitChange (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, doubleunit) { // 切换大小规格
            let params = unitChange (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, doubleunit, minorderunit, this.outstock)
            item.unitshow = params.unitshows
            item.num = params.nums
        },
        addGoods () { // 添加单规格商品到购物车
            if (!this.banorder.error) { // 判断orderlimit.error是否限制下单
                if (this.outstock <= 0 && this.hasstock == 0) {
                    this.$Message.warning('该商品暂时缺货')
                } else {
                    this.addtocart()
                }
            } else {
                // 弹出提示-限制原因
                this.$Message.warning(this.banorder.msg)
            }
        },
        addtocart () { // 商品加入购物车判断条件
            /**
             * 暂无
             * 促销商品限制，暂时没有字段
             */
            if (this.goodsinfo.is_det == 0) { // 判断商品是单规格还是多规格 0 单规格 1 多规格
                if (this.goodsinfo.num > 0) { // 判断num是否为0
                    this.inspect()
                } else { // 判断num是否为0
                    this.$Message.warning('购买数量不能为0')
                }
            } else {
                for (var i = 0; i < this.det.length; i++) {
                    if (this.det[i].num > 0) {
                        this.inspect()
                        break
                    } else if (i == this.det.length-1) {
                        this.$Message.warning('购买数量不能为0')
                    }
                }
            }
        },
        inspect () { // 添加购物车时，判断产品是否失效
            let ggidarr = []
            let goodnumarr = []
            let unitshowarr = []
            let newItem = [] // 添加到购物车的字段
            
            if (this.goodsinfo.is_det == 0) { // 判断商品是单规格还是多规格 0 单规格 1 多规格
                newItem.push({
                    gg_id: this.det.gg_id, // 规格id
                    id: this.goodsinfo.id, // 商品id
                    is_det: this.goodsinfo.is_det, // 0 单规格 1 多规格
                    num: this.goodsinfo.num, // 商品数量
                    unitshow: this.goodsinfo.unitshow, // 大小单位切换 false 小 true 大
                    remarks: '', // 备注信息
                })
            } else {
                for (var i = 0; i < this.det.length; i++) {
                    if (this.det[i].num > 0) {
                        newItem.push({
                            gg_id: this.det[i].gg_id, // 规格id
                            id: this.goodsinfo.id, // 商品id
                            is_det: this.goodsinfo.is_det, // 0 单规格 1 多规格
                            num: this.det[i].num, // 商品数量
                            unitshow: this.det[i].unitshow, // 大小单位切换 false 小 true 大
                            remarks: '', // 备注信息
                        })
                    }
                }
            }
            for (var i = 0; i < newItem.length; i++) {
                ggidarr.push(newItem[i].gg_id)
                goodnumarr.push(newItem[i].num)
                unitshowarr.push(newItem[i].unitshow)
            }
            this.http.post(api.goodscheck,
                {
                    gid: ggidarr.join(','),
                    goodnum: goodnumarr.join(','),
                    unitshow: unitshowarr.join(','),
                }
            )
            .then(response => {
                console.log(response.data.msg)
                // 添加id购物车到缓存
                this.$store.dispatch('addShopCartList', newItem)
                // 添加成功显示加入购物车标识
                if (this.goodsinfo.is_det == 0) { // 0 单规格 1 多规格
                    for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                        if (this.$store.state.shopcartlist[i].gg_id == this.det.gg_id) {
                            // 是否加入购物车图标
                            this.goodsinfo.carcheck = true
                        }
                    }
                } else {
                    for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                        for (var j = 0; j < this.det.length; j++) {
                            if (this.$store.state.shopcartlist[i].gg_id == this.det[j].gg_id) {
                                // 是否加入购物车图标
                                this.det[j].carcheck = true
                            }
                        }
                    }
                }
                // 添加成功提示
                this.$Message.success('添加购物车成功')
                // 多规格弹窗添加成功之后隐藏
                this.manynorms = false
            })
            .catch(error => {
                this.$Message.error(error);
            })
        },
        collectclick () { // 收藏商品
            if (!this.$store.state.openmall) {
                this.http.post(api.checkgoods, {id: this.goodsinfo.id})
                .then(response => {
                    this.http.post(api.goodscollect, {goodsid: this.goodsinfo.id})
                    .then(response => {
                        this.$Message.success(response.data.msg)
                        this.getGoodsDetails()
                    })
                    .catch(error => {
                        this.$Message.error(error)
                    })
                })
                .catch(error => {
                    this.$Message.error(error)
                })
            } else {
                this.nologintipsmsg = '未登录客户不可收藏，请登录'
                this.nologinShow = true
            }
        },
        getGoodsBrowsingHistory () { // 获取商品浏览记录
            this.http.post(api.historygoods, {ids: this.$store.state.goodsBrowsingHistory})
            .then(response => {
                console.log(response.data.msg)
                this.goodsBrowsingHistory = response.data.msg.goodslistids
            })
            .catch(error => {
                console.log(error);
            })
        },
        goto (id) { // 跳转详情页
        
            this.$router.push({
                name: '商品详情',
                params: {
                    id: id
                }
            })
            this.getGoodsDetails()
        },
        nologinOk () {
            this.nologinShow = false
        },
        nologinCancel () {
            this.nologinShow = false
        }
    },
    created () {
        this.$store.dispatch('addgoodsidFun', this.$route.params.id)
        this.getGoodsDetails()
        this.getGoodsBrowsingHistory()
    }
}
</script>

<style scoped>

.goods_details_interval {
    flex-grow: 0;
    flex-shrink: 0;
    background-color: #F9F9FD;
}

.goods_details_interval.h {
    height: 20px;
}

.goods_details_interval.v {
    width: 18px;
    margin-bottom: -30px;
}

.goods_details_top_content {
    padding: 30px;
    display: flex;
    flex-direction: row;
}

.img_magnifier_content {
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 60px;
}

.goods_info_content {
    width: 10px;
    flex-grow: 1;
    flex-shrink: 1;
}

.goods_info_top {
    padding-bottom: 20px;
}

.goods_info_name > h3 {
    font-size: 20px;
    color: #333;
    font-weight: normal;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.goods_info_price > span {
    margin-right: 20px;
    font-size: 14px;
    color: #999;
}

.goods_info_price > span:last-child {
    margin-right: 0;
}

.goods_info_specialoffer {
    display: flex;
    flex-direction: row;
    padding-top: 5px;
}

.goods_info_specialoffer > span,
.goods_info_label > span {
    flex-grow: 0;
    flex-shrink: 0;
    height: 20px;
    line-height: 20px;
    padding: 0 6px;
    margin-right: 10px;
    font-size: 14px;
    color: #fff;
    border-radius: 2px;
    background-color: #FF8000;
}

.goods_info_specialoffer > small {
    font-size: 14px;
    color: #333;
    word-break: break-all;
}

.goods_info_label {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-top: 10px;
}

.goods_info_bottom {
    padding-top: 20px;
    margin-top: 20px;
    border-top: 1px solid #E6E6E6;
}

.goods_info_btn {
    height: 48px;
    margin-right: 18px;
    font-size: 16px;
}

.goods_info_btn:last-child {
    margin-right: 0;
}

.goods_info_btn .ivu-icon {
    vertical-align: -4px;
}

.goods_info_btn.collect {
    border-color: #ccc;
    color: #ccc;
}

.goods_details_bottom_content {
    display: flex;
    flex-direction: row;
}

.goods_details_introduce_content {
    width: 10px;
    flex-grow: 1;
    flex-shrink: 1;
    padding: 0 30px;
}

.goods_details_introduce_box {
    padding-top: 10px;
}

.goods_details_introduce_describe img {
    max-width: 100% !important;
}

.goods_details_introduce_table > table {
    width: 100%;
    border: 1px solid #ebeef7;
}

.goods_details_introduce_table > table > tbody > tr > th {
    font-size: 14px;
    color: #666;
    font-weight: normal;
    white-space: nowrap;
    background-color: #f9f9fd;
    border: 1px solid #ebeef7;
}

.goods_details_introduce_table > table > tbody > tr > td {
    height: 40px;
    padding: 10px;
    border: 1px solid #ebeef7;
    word-break: break-all;
}

.goods_info_center {
    border-top: 1px solid #E6E6E6;
}

.goods_browsinghistory_content {
    width: 430px;
    flex-grow: 0;
    flex-shrink: 0;
    padding: 0 30px 0;
}

.goods_browsinghistory_list {
    margin-top: -16px;
}

.goods_browsinghistory_list > ul > li {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #F5F5F5;
    cursor: pointer;
}

.goods_browsinghistory_left {
    width: 64px;
    height: 64px;
    margin-right: 10px;
    background-position: center;
    background-size: cover;
}

.goods_browsinghistory_right {
    width: 10px;
    height: 64px;
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 4px 0;
}

.goods_browsinghistory_name > h3 {
    font-size: 14px;
    color: #333;
    font-weight: normal;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

</style>


// WEBPACK FOOTER //
// src/components/views/goods/goodsdetails.vue